<template>
</template>

<script>

const TAG = '[ALLBACK]'

export default {
  name: 'bindGuidePage',
  data () {
    return {}
  },
  methods: {},
  mounted () {
    this.$router.go(-1)
    console.log(TAG, 'mounted')
  },
  activated () {
    this.$router.go(-1)
    console.log(TAG, 'activated')
  }
}
</script>

<style scoped lang="less" src="@/styles/common.less"/>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/supplierAllBack.vue